import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_staff/attendance-core/_layout/')({
  beforeLoad: () => {
    throw redirect({ to: '/attendance-core/dashboard' });
  },
});
